function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "",
  d: "M216.2,178.6H35.6c-15.9,0-28.8-12.9-28.8-28.8v-116h7v116c0,12,9.8,21.8,21.8,21.8h178.8v-35.5h7v37.3 C221.4,176.3,219.1,178.6,216.2,178.6z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "",
  d: "M221.4,81.7h-7V54.1c0-0.6-0.2-0.9-0.4-1.1s-0.5-0.4-1-0.4H28.8c-12.1,0-22-9.9-22-22c0-12.1,9.9-22,22-22 h172.2c4.9,0,8.8,3.9,8.8,8.8v28.2h3.2c2.3,0,4.4,0.9,6,2.5c1.6,1.6,2.4,3.8,2.4,6.1L221.4,81.7z M28.8,15.6c-8.3,0-15,6.7-15,15 c0,8.3,6.7,15,15,15h174V17.4c0-1-0.8-1.8-1.8-1.8H28.8z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "",
  d: "M163.6,35.8H32c-2.5,0-4.5-2-4.5-4.5v0c0-2.5,2-4.5,4.5-4.5h131.6c2.5,0,4.5,2,4.5,4.5v0 C168.2,33.8,166.1,35.8,163.6,35.8z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "",
  d: "M191.5,35.8h-6.8c-2.5,0-4.5-2-4.5-4.5v0c0-2.5,2-4.5,4.5-4.5h6.8c2.5,0,4.5,2,4.5,4.5v0 C196.1,33.8,194,35.8,191.5,35.8z"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "",
  d: "M222.8,143.5h-36.5c-17.1,0-30.9-13.9-30.9-30.9c0-18.7,15.2-34,34-34h33.5c7,0,12.7,5.7,12.7,12.7v39.4 C235.6,137.8,229.9,143.5,222.8,143.5z M189.3,86.6c-14.3,0-26,11.7-26,26c0,12.6,10.3,22.9,22.9,22.9h36.5c2.6,0,4.7-2.1,4.7-4.7 V91.4c0-2.6-2.1-4.7-4.7-4.7H189.3z"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "",
  d: "M187.4,127c-8.3,0-15-6.7-15-15s6.7-15,15-15s15,6.7,15,15S195.6,127,187.4,127z M187.4,105.1 c-3.8,0-7,3.1-7,7s3.1,7,7,7s7-3.1,7-7S191.2,105.1,187.4,105.1z"
}));

var SvgWallet = function SvgWallet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 241.8 186.3",
    style: {
      enableBackground: "new 0 0 241.8 186.3"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wallet.77f15853.svg";
export { ForwardRef as ReactComponent };